module.exports = __webpack_public_path__ + "static/img/24.6b344253.png";